import Vue from 'vue'
import * as util from '../../vendor/util'
import {cloneMe} from "@/vendor/util";
import {filterEmptyCategoriesWithSections} from "../../vendor/qconstants";
import {getGlobalValue} from "../../util/globalState";

const enableShowAllCats = false;
const enableShowAllItems = false;

function getItemById(categories, itemId) {
  for (let category of categories) {
    let item = category.items.find(u => u.id === itemId);
    if (item) {
      return item
    }
  }
  return null;
}

function getItemByName(categories, name) {
  if (name) {
    for (let category of categories) {
      if (category.items) {
        let item = category.items.find(u => u.nameDE && u.nameDE.toLowerCase() === name.toLowerCase());
        if (item) {
          return item
        }
      }
    }
  }
  return null;
}

function filterGlobalExtras(state, rootGetters, cats) {
  let globalExtras = rootGetters.appconfig.globalExtras;
  let inactiveExtras = [];
  if (globalExtras && globalExtras.length > 0) {
    console.log('globalExtras GIVEN');
    for (let e of globalExtras) {
      if (!e.active && e.label) {
        let l = util.withoutSplits(e.label.toLowerCase().trim());
        inactiveExtras.push(l);
      }
    }

    console.log('inactiveExtras globalExtras = ' + JSON.stringify(inactiveExtras));

    for (let cat of cats) {
      if (!cat.items) {
        continue;
      }
      for (let item of cat.items) {
        if (item.extras && item.extras.variants) {
          for (let step of item.extras.variants) {
            if (!step.options) {
              continue;
            }
            for (let i = 0; i < step.options.length; i++) {
              let option = step.options[i];
              let t = option.labelDE.toLowerCase().trim();
              let l = util.withoutSplits(t);
              option.active = !inactiveExtras.includes(l);
              if (option.active) {
                let noh = util.noHtml(t);
                option.active = !inactiveExtras.includes(noh);
              }
              if (!option.active) {
                console.log('option filtered by globalExtras ' + l);
              }
              // console.log('option activ: ' + !!option.active + option.labelDE);
              // if (inactiveExtras.includes(option.labelDE.toLowerCase())) {
              //     itm.extras.variants.splice(i--, 1);
              // }
            }
          }
        }
      }
    }
  } else {
    console.log('globalExtras EMPTY');
  }
}

function isWithinOrderTimes(times, categoryName) {
  let rNow = new Date();
  let currentHour = rNow.getHours();
  let currentMinutes = rNow.getMinutes();

  let withinOrderTimes = true;
  if (times) {
    if (times.validFrom) {
      try {
        let fIdx = times.validFrom.indexOf(':');
        let fromHour = parseInt(times.validFrom.substring(0, fIdx), 10);
        let fromMinute = parseInt(times.validFrom.substring(fIdx + 1, 5), 10);

        if (currentHour < fromHour) {
          console.log('filter out cat by orderTimes fromHour ' + categoryName);
          withinOrderTimes = false;
        }

        if (currentHour === fromHour) {
          if (currentMinutes < fromMinute) {
            console.log('filter out cat by orderTimes fromMinute ' + categoryName);
            withinOrderTimes = false;
          }
        }

      } catch (e) {
        console.log('Error in validFrom parsing: ' + e.message);
      }
    }
    if (times.validTo) {
      try {
        let tIdx = times.validTo.indexOf(':');
        let tillHour = parseInt(times.validTo.substring(0, tIdx), 10);
        let tillMinute = parseInt(times.validTo.substring(tIdx + 1, 5), 10);

        if (currentHour > tillHour) {
          console.log('filter out cat by orderTimes tillHour ' + categoryName);
          withinOrderTimes = false;
        }

        if (currentHour === tillHour) {
          if (currentMinutes > tillMinute) {
            console.log('filter out cat by orderTimes tillMinute ' + categoryName);
            withinOrderTimes = false;
          }
        }
      } catch (e) {
        console.log('Error in validTo parsing: ' + e.message);
      }
    }
    return withinOrderTimes;
  } else {
    return true;
  }
}

function filterMenuForDisplay(forDrink, state, rootState, rootGetters, _cats) {
  if (!_cats) {
    return [];
  }
  try {
    console.log('xxxFilter: ... ' + Date.now());
    let clone = cloneMe(_cats);
    let cats = clone.filter(c => typeof c !== 'undefined');
    filterGlobalExtras(state, rootGetters, cats);
    let relevantCats = [];
    let finalRelevantCats = [];
    try {
      //filter out menu by time
      let rNow = new Date();
      let currentHour = rNow.getHours();
      let currentMinutes = rNow.getMinutes();

      let today = '' + util.getWeekdayAsNum();
      console.log('today = ' + today);

      for (let cat of cats) {

        // if (cat.categoryDE === 'Pizza') {
        //   // alert('Pizza items in menustore filter: ' + cat.items.length);
        // }
        // if (cat.categoryDE !== 'Pizza') {
        //   relevantCats.push(cat);
        //   continue;
        // }

        // ***************************
        // Fix default values
        // ***************************
        let inventoryData = [];
        if (rootGetters.enableBestand) {
          inventoryData = getGlobalValue('inventoryData') || [];
        }

        if (cat.items) {
          for (let itm of cat.items) {

            if (!('buyable' in itm)) {
              itm.buyable = true;
            }

            if (itm.image && itm.image.startsWith('file:')) {
              itm.image = '';
            }

            if (Vue.ls.get('guestMode') || (itm.days && !itm.days.includes(today))) {
              // disable ordering
              console.log('set buyable to false because item.days is missing today=' + today
                + ' item.days=' + JSON.stringify(itm.days, null, 2)
                + ' for item=' + itm.nameDE);
              itm.buyable = false;
            }

            if (typeof (itm.bestand) === 'undefined' || !rootGetters.enableBestand) {
              itm.bestand = -1; // hasBestand = false
            }
            itm.redAvailabilityInfo = '';
            if (rootGetters.enableBestand) {
              const posId = itm.posId;
              console.log('bestand check 4.0 for posId: ' + posId);
              let iData = inventoryData.find(i => i.posId === posId);
              if (iData) {
                itm.bestand = iData.currentStock;
                console.log('set bestand ' + itm.bestand + ' to item ' + itm.nameDE);
                if (iData.currentStock <= 0) {
                  itm.buyable = false;
                  itm.redAvailabilityInfo = 'ausverkauft';
                }
              }
            }

            if (typeof (itm.lieferzeit) === 'undefined') {
              itm.lieferzeit = '';
            }
            if (typeof (itm.num) !== 'undefined') {
              itm.articleNo = itm.num;
            }

            //inherit days from category to item
            if (cat.days) {
              itm.days = cloneMe(cat.days);
            }

          }
        }

        // ***************************
        // Filter required for all use cases
        // ***************************

        //filter out menu by days
        if (!enableShowAllCats) {
          if (cat.days) {
            if (!cat.days.includes(today)) {
              console.log('filter out missing cat day ' + cat.categoryDE);
              continue;
            }
            console.log('cat day exists for ' + cat.categoryDE);
          }
        }
        if (!cat.items) {
          cat.items = [];
        }
        for (let item of cat.items) {
          item.withinOrderTimes = true;
        }

        if (cat.orderTimes) {
          // if (cat.orderTimes && state.inhouse) {
          // orderTimes:{
          //     '1':{
          //         validFrom: ...
          //         validTo: ...
          //     },
          //     '4':{
          //         validFrom: ...
          //         validTo: ...
          //     }
          // }
          let times = cat.orderTimes[today];
          let ot2 = cat.orderTimes2 || {};
          let times2 = ot2[today];
          let withinOrderTimes = true;
          if (times?.validFrom || times?.validTo) {
            if (!times?.validFrom) {
              times.validFrom = '00:00';
            }
            withinOrderTimes = isWithinOrderTimes(times, cat.categoryDE);
          }
          if (!withinOrderTimes && (times2?.validFrom || times2?.validTo)) {
            if (!times2?.validFrom) {
              times2.validFrom = '00:00';
            }
            withinOrderTimes = isWithinOrderTimes(times2, cat.categoryDE)
          }

          cat.withinOrderTimes = withinOrderTimes;

          for (let item of cat.items) {
            item.withinOrderTimes = withinOrderTimes;
          }

          // if (!withinOrderTimes) {
          //   if (enableShowAllCats) {
          //   } else {
          //     continue;
          //   }
          // }
        } else {
          cat.withinOrderTimes = true;
        }

        if (cat.days) {
          if (!cat.days.includes(today)) {
            console.log('set buyable to false for all items of category '
              + cat.categoryDE);
            cat.items.forEach(item => {
              if (item) {
                item.buyable = false;
              }
            })
          }
        }

        let loadedStoreId = false; //window.loadedStoreId || false;

        if (loadedStoreId) {
          if (cat.validStores && cat.validStores.length > 0) {
            if (!cat.validStores.includes(loadedStoreId)) {
              console.log('filtered cat by loadedStoreId ' + loadedStoreId + ' not included in validStores of category '
                + cat.categoryDE);
              continue;
            }
          }
        }

        if (loadedStoreId && cat.fmConfig) {
          if (cat.fmConfig[loadedStoreId]) {
            if (!cat.fmConfig[loadedStoreId].active) {
              console.log('filter inactive category: ' + cat.categoryDE);
              continue;
            }
          } else {
            console.log('fmConfig is empty');
          }
        }

        // if (state.inhouse) {
        //   // cat.validFromHour and validFromHour are outdated; use cat.orderTimes instead
        //   if (cat.validFromHour) {
        //     try {
        //       let fIdx = cat.validFromHour.indexOf(':');
        //       let fromHour = parseInt(cat.validFromHour.substring(0, fIdx), 10);
        //       let fromMinute = parseInt(cat.validFromHour.substring(fIdx + 1, 5), 10);
        //
        //       if (currentHour < fromHour) {
        //         continue;
        //       }
        //
        //       if (currentHour === fromHour) {
        //         if (currentMinutes < fromMinute) {
        //           continue;
        //         }
        //       }
        //
        //     } catch (e) {
        //       console.log('Error in validFromHour parsing: ' + e.message);
        //     }
        //   }
        //   if (cat.validTillHour) {
        //     try {
        //       let tIdx = cat.validTillHour.indexOf(':');
        //       let tillHour = parseInt(cat.validTillHour.substring(0, tIdx), 10);
        //       let tillMinute = parseInt(cat.validTillHour.substring(tIdx + 1, 5), 10);
        //
        //       if (currentHour > tillHour) {
        //         continue;
        //       }
        //
        //       if (currentHour === tillHour) {
        //         if (currentMinutes > tillMinute) {
        //           continue;
        //         }
        //       }
        //
        //     } catch (e) {
        //       console.log('Error in validTillHour parsing: ' + e.message);
        //     }
        //   }
        // }

        // ***************************
        // Filter items
        // ***************************

        let preRelevantItemsForCat = [];
        // console.log('check filter for cat '+cat.categoryDE +' which has '+cat.items.length+' items');
        for (let item of cat.items) {

          if (loadedStoreId) {
            if (item.validStores && item.validStores.length > 0) {
              if (!item.validStores.includes(loadedStoreId)) {
                continue;
              }
            }
          }

          if (loadedStoreId && item.fmConfig) {
            if (item.fmConfig[loadedStoreId]) {
              if (item.fmConfig[loadedStoreId].active) {
                preRelevantItemsForCat.push(item);
              } else {
                console.log('filter inactive item: ' + item.nameDE);
              }
            } else {
              preRelevantItemsForCat.push(item);
            }
          } else {
            preRelevantItemsForCat.push(item);
          }
          // if (state.inhouse) {
          //
          // } else {
          //   preRelevantItemsForCat.push(item);
          // }
        }//eof loop items of cat

        preRelevantItemsForCat = preRelevantItemsForCat.filter(item => {

          let iu = (typeof item.inhouseOnly === 'undefined');
          let tu = (typeof item.takeawayOnly === 'undefined');
          // console.log('debug rootGetters.enableInhousePay: ' + (!!rootGetters.enableInhousePay));//it works

          if ((iu && tu) || (!item.inhouseOnly && !item.takeawayOnly)) {
            if (rootGetters.enableInhouseOhnePay || rootGetters.enableInhousePay) {
              item.buyableForInhouse = true;
            }
            if (rootGetters.enableTakeawayOhnePay || rootGetters.enableTakeawayPay) {
              item.buyableForTakeaway = true;
            }
          } else {
            item.buyableForInhouse = !!((!iu || item.inhouseOnly) && (tu || !item.takeawayOnly));
            item.buyableForTakeaway = !!((!tu || item.takeawayOnly) && (iu || !item.inhouseOnly));
          }

          if (!enableShowAllItems) {
            if (item.days) {
              if (!item.days.includes(today)) {
                console.log('filter out item by missing cat day ' + item.nameDE);
                return false
              }
            }

            if (rootGetters.inhouse) {
              let x = item.buyableForInhouse;
              if (!x) {
                console.log('filter out item by buyableForInhouse ' + item.nameDE);
                return false
              }
            } else {
              let x = item.buyableForTakeaway;
              if (!x) {
                console.log('filter out item by buyableForTakeaway ' + item.nameDE);
                return false
              }
            }

          }

          return true;
        });

        let relevantItemsForCat = [];
        for (let item of preRelevantItemsForCat) {
          if (filterEmptyCategoriesWithSections && !item.section) {
            relevantItemsForCat.push(item);
          }
        }
        if (relevantItemsForCat.length > 0) {
          relevantItemsForCat = preRelevantItemsForCat;
          cat.items = relevantItemsForCat;
          relevantCats.push(cat);
        } else {
          //side effect: cats which have only sections will be empty
        }
      }//eof loop of cats

      // ***************************
      // Filter cats with empty items
      // ***************************

      for (let cat of relevantCats) {
        // if (cat.categoryDE !== 'Pizza') {
        //   finalRelevantCats.push(cat);
        //   continue;
        // }

        if (!enableShowAllCats && !cat.withinOrderTimes) {
          console.log('filter out cat by withinOrderTimes ' + cat.categoryDE);
          continue;
        }

        let anyItem = false;
        for (let item of cat.items) {
          // if (!item.section) {
          anyItem = true;
          break
          // }
        }
        if (anyItem) {
          finalRelevantCats.push(cat);
        }
      }
    } catch (outerE) {
      console.log('Error in filterMenuForDisplay: ' + outerE.message);
    }
    // if (!forDrink) {
    //   console.log('number of Vorspeise in finalRelevantCats: ' +
    //     finalRelevantCats.reduce((arr, e, i) => (e.categoryDE === 'Vorspeisen' && arr.push(i), arr), []).length
    //   );
    // }
    return finalRelevantCats;
  } catch (e) {
    console.log('Error in filterMenuForDisplay: ' + e.message);
    return _cats;
  }
}

export default {
  state: {
    drinkMenu: [{aaaRefresh: 0}],
    foodMenu: [{aaaRefresh: 0}],
    lastModifiedFoodMenu: 0,
    lastModifiedDrinkMenu: 0,
    drinkMenuLoaded: false,
    foodMenuLoaded: false,
    menuSearchPhrase: '',
  },
  actions: {
    // refreshFoodMenu(context, language) {
    //   context.commit("foodMenu", []);
    //   setTimeout(() => {
    //     context.commit("foodMenu", []); = c;
    //   }, 600);
    // }
  },
  mutations: {
    menuSearchPhrase(state, newValue) {
      state.menuSearchPhrase = newValue || '';
    },
    triggerRefreshFoodMenu(state, newValue) {
      let r = state.foodMenu.find(i => typeof i.aaaRefresh !== 'undefined');
      if (!r) {
        state.foodMenu.push({aaaRefresh: Date.now()})
      } else {
        r.aaaRefresh = Date.now();
      }
    },
    triggerRefreshDrinkMenu(state, newValue) {
      let r = state.drinkMenu.find(i => typeof i.aaaRefresh !== 'undefined');
      if (!r) {
        state.drinkMenu.push({aaaRefresh: Date.now()})
      } else {
        r.aaaRefresh = Date.now();
      }
    },
    lastModifiedFoodMenu(state, newValue) {
      state.lastModifiedFoodMenu = newValue;
    },
    lastModifiedDrinkMenu(state, newValue) {
      state.lastModifiedDrinkMenu = newValue;
    },
    foodMenu(state, categories) {
      Vue.set(state, 'foodMenu', [...categories]);
      // console.log('???food menu loaded length: ' + state.foodMenu.length);
      // console.log('foodeMenu item1 = '+state.foodMenu[0].items[0].nameDE);
      state.foodMenuLoaded = true;
    },
    drinkMenu(state, categories) {
      Vue.set(state, 'drinkMenu', [...categories]);
      state.drinkMenuLoaded = true;
    },
  },
  getters: {
    menuSearchPhrase: (state) => {
      return state.menuSearchPhrase;
    },
    allFoodMenu: (state, getters, rootState, rootGetters) => {
      return state.foodMenu;
    },
    foodMenu: (state, getters, rootState, rootGetters) => {
      return filterMenuForDisplay(false, state, rootState, rootGetters, state.foodMenu);
    },
    allDrinkMenu: (state, getters, rootState, rootGetters) => {
      return state.drinkMenu;
    },
    drinkMenu: (state, getters, rootState, rootGetters) => {
      return filterMenuForDisplay(true, state, rootState, rootGetters, state.drinkMenu);
    },

    getFoodCategoryByName: (state) => (name) => {
      try {
        for (let category of state.foodMenu) {
          if (name.toLowerCase().includes(category.categoryDE.toLowerCase())) {
            return category;
          }
        }
      } catch (e) {

      }
      return undefined;
    },

    getFoodById: (state, getters, rootState, rootGetters) => (itemId) => {
      return getItemById(filterMenuForDisplay(false, state, rootState, rootGetters, state.foodMenu), itemId);
    },
    getDrinkById: (state, getters, rootState, rootGetters) => (itemId) => {
      return getItemById(filterMenuForDisplay(true, state, rootState, rootGetters, state.drinkMenu), itemId);
    },

    // getFoodItemByName:  (state, getters, rootState, rootGetters) => (itemId) => {
    //   return getItemByName(state.foodMenu, name);
    // },

    getCategoryByItemId: (state, getters, rootState, rootGetters) => (itemId) => {
      for (let category of filterMenuForDisplay(false, state, rootState, rootGetters, state.foodMenu)) {
        let item = category.items.find(i => i?.id && i.id === itemId);
        if (item) {
          return category;
        }
      }
      return undefined;
    },

    // getCategoryByName: (state) => (name) => {
    //   for (let category of state.foodMenu) {
    //     if (category.categoryDE === name) {
    //       return category;
    //     }
    //   }
    //   return undefined;
    // },
    getDrinkCategoryByItemId: (state, getters, rootState, rootGetters) => (itemId) => {
      for (let category of filterMenuForDisplay(true, state, rootState, rootGetters, state.drinkMenu)) {
        let item = category.items.find(i => i?.id && i.id === itemId);
        if (item) {
          return category;
        }
      }
      return undefined;
    },
  }
};
